module.exports = __webpack_public_path__ + "hyperion-v2-static/img/resources_the_daily.bbd32b33.png";